function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = parseInt(this.input.value);
    const minValue = parseInt(this.input.getAttribute('min'));
    if( event.target.name === 'plus'){
      this.input.setAttribute("placeholder", previousValue + 1);
      this.input.setAttribute("value", previousValue + 1);
      event.currentTarget.parentNode.querySelector('[name="minus"]').classList.remove('disabled');
    }else if(event.target.name === 'minus'){
      if( previousValue > minValue){
        this.input.setAttribute("placeholder", previousValue - 1);
        this.input.setAttribute("value", previousValue - 1);
      }else{
        event.currentTarget.classList.add("disabled");
      }
    }
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        let region;
        if(opt.value == 'Hong Kong Island'){
          region = 'hk';
          opt.innerHTML = 'Hong Kong Island (香港島)';
        } else if (opt.value == 'Kowloon') {
          region = 'kl'
          opt.innerHTML = 'Kowloon (九龍)';
        } else {
          region = 'nt'
          opt.innerHTML = 'New Territories (新界)';
        }

        opt.setAttribute('data-region',region)
        this.provinceEl.appendChild(opt);

        if(this.provinceEl.dataset.default == '香港') {
          this.provinceEl.value = 'Hong Kong Island'
        } else if (this.provinceEl.dataset.default == '九龍') {
          this.provinceEl.value = 'Kowloon'
        } else if(this.provinceEl.dataset.default == '新界') {
          this.provinceEl.value = 'New Territories'
        }
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', function(e){this.onVariantChange(e)});
  }

  getThreeOptions() {
    let option1,option2,option3;
    let radioOptionFirst = this.querySelectorAll('input[data-option-seq="option-1"]');
    let radioOptionSecond = this.querySelectorAll('input[data-option-seq="option-2"]');
    let radioOptionThird = this.querySelectorAll('input[data-option-seq="option-3"]');

    if(radioOptionFirst) {
        radioOptionFirst.forEach(function(el){
          if (el.checked) {
            option1 = el.value;
          }
        })
    }

    if(radioOptionSecond) {
        radioOptionSecond.forEach(function(el){
          if (el.checked) {
            option2 = el.value;
          }
        })
    }

    if(radioOptionThird) {
        radioOptionThird.forEach(function(el){
          if (el.checked) {
            option3 = el.value;
          }
        })
    }
    return {option1 ,option2,option3}
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateSwatch(e);
    }
    this.updateVariantBadge();
    this.optionSoldoutCheck(e)
  }

  optionSoldoutCheck(e) {
    const optionsObjects = this.getThreeOptions();
    let option_size = this.querySelector('select[data-js-variants]').dataset.productOptions;
    const notlastClicked = e.target.closest('fieldset').classList.contains('last_options_el');
    const selectEl = this.querySelectorAll('select[data-js-variants] option');
    const last_option_selector = this.querySelectorAll('fieldset.last_options_el input[type="radio"]');
    const thisValue = e.target.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

    if(parseInt(option_size) > 1 && !notlastClicked) {

      let soldout_options = [];
      let avail_options =[]
      selectEl.forEach(function(select){
          let option1_name = select.dataset.voption1;
          let option2_name = select.dataset.voption2;
          let option3_name = select.dataset.voption3;
          let is_variant_avail = select.dataset.available;

          if(thisValue == option1_name) {
              if (is_variant_avail == 'false') {
                  soldout_options.push(option2_name)
                  soldout_options.push(option3_name)
              } else {
                  avail_options.push(option2_name)
                  avail_options.push(option3_name)
              }
          } else if (thisValue == option2_name) {
              if (is_variant_avail == 'false') {
                  soldout_options.push(option1_name)
                  soldout_options.push(option3_name)
              } else {
                  avail_options.push(option1_name)
                  avail_options.push(option3_name)
              }
          } else if (thisValue == option3_name) {
              if (is_variant_avail == 'false') {
                  soldout_options.push(option1_name)
                  soldout_options.push(option2_name)
              } else {
                  avail_options.push(option1_name)
                  avail_options.push(option2_name)
              }
          }
      });
      if(avail_options.length == 0) {
        last_option_selector.forEach(function(e){
            e.classList.add('soldout')
        })
      } else {
        last_option_selector.forEach(function(e){
            var thisValue = e.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            if(avail_options.includes(thisValue)) {
              e.classList.remove('soldout')
            } else {
              e.classList.add('soldout')
            }
          })
      }
    }
  }

  updateSwatch(e){

    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      if((!this.currentVariant?.available && parseInt(e.target.getAttribute("data-option-index")) == 1)) {
        document.querySelectorAll(".option2_for_below_input input:not(.soldout)+label")[0].click();
      }
      if(fieldsets[0] == fieldset ){
        const $this = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);

        var thisValue = $this.getAttribute("value");
        var data_option1= $this.getAttribute('data_option1');
        var data_option2 = $this.getAttribute('data_option2');
        var data_option3 = $this.getAttribute('data_option3');
        var lastChar2 = data_option2.slice(-1);
        if (lastChar2 == ',') {
          data_option2 = data_option2.slice(0, -1);
        }
        var data_option2Array = ( typeof data_option2 != "undefined" &&  data_option2 != '' )? data_option2.split(",") : false ;
        data_option2Array && fieldsets[1] && [...fieldsets[1].querySelectorAll('input')].forEach(function(element){
          var element_value = element.value.replace(/\"/g,"");
          // if(data_option2Array.indexOf(element_value) > -1 ){
          //   element.classList.add('available');
          //   element.classList.remove('soldout');
          // }else{
          //   element.classList.remove('available');
          //   element.classList.add('soldout');
          // }
        });
         var lastChar3 = data_option3.slice(-1);
        if (lastChar3 == ',') {
          data_option3 = data_option3.slice(0, -1);
        }
        var data_option3Array = ( typeof data_option3 != "undefined" &&  data_option3 != '' )? data_option3.split(",") : false ;
        data_option3Array && fieldsets[2] && [...fieldsets[2].querySelectorAll('input')].forEach(function(element2){
          // if(data_option3Array.indexOf(element2.value) > -1 ){
          //   element2.classList.add('available');
          //   element2.classList.remove('soldout');
          // }else{
          //   element2.classList.remove('available');
          //   element2.classList.add('soldout');
          // }
        });

        if(data_option2Array &&  fieldsets[1] ){
          var triggerOption2 = data_option2Array[0].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
//           fieldsets[1].querySelector(".option2_for_below_input .input-"+triggerOption2).click();
        }

        if(data_option3Array &&  fieldsets[2] ){
          var triggerOption3 = data_option3Array[0].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
          // fieldsets[2].querySelector(".option3_for_below_input .input-"+triggerOption3).click();
        }
          if(data_option2Array || data_option3Array ){
          }else{
          }
      }

       if(fieldsets[1] == fieldset ){
       }
      var inventoryQty =this.getAttribute('data_'+this.currentVariant?.id);

      let meta_qty_low = this.getAttribute('data-meta-low')
      var minQty = this.getAttribute('data-min-qty');
      const stockmsg = this.querySelector('#stockmsg');
      if(meta_qty_low == 'true') {
        if(inventoryQty >= 10){stockmsg.innerHTML="In stock";}
        else if(inventoryQty <= 10 && inventoryQty > 0 && inventoryQty >= minQty){ stockmsg.innerHTML="Low in stock"; }
        else if(inventoryQty <= 10 && inventoryQty > 0 && inventoryQty >= minQty){ stockmsg.innerHTML="in stock"; }
        else{ stockmsg.innerHTML="Out of stock"; }
      } else {
        if(inventoryQty >= 10){stockmsg.innerHTML="In stock";}
        else if(inventoryQty <= 10 && inventoryQty > 0 && inventoryQty >= minQty){ stockmsg.innerHTML="in stock"; }
        else if(inventoryQty <= 10 && inventoryQty > 0 && inventoryQty >= minQty){ stockmsg.innerHTML="Out of stock"; }
        else{ stockmsg.innerHTML="Out of stock"; }
      }

      const thisProductId = `${this.getAttribute("id")}`;
      const productForms = document.querySelectorAll(`.variantselec #product-form-installment, #qvproduct_form_${thisProductId}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
  if( typeof this.currentVariant.featured_media != "undefined"){

    var media_id = this.currentVariant.featured_media.id;
    var media_position = this.currentVariant.featured_image.position;
    const bodyHasClass = document.body.classList.contains('new_quick_view_open');
    const bodyHasClassProduct = document.body.classList.contains('product');
    if (!bodyHasClass && bodyHasClassProduct) {
      var galleryThumbs = new Swiper(".gallery-thumbs", {
        centeredSlides: false,
        slidesPerView: 4,
        watchOverflow: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        direction: 'vertical'
      });
      var galleryMain = new Swiper(".gallery-main", {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        thumbs: {
          swiper: galleryThumbs
        }
      });
      galleryMain.slideTo( media_position - 1,1000,false );
      galleryMain.on('slideChangeTransitionStart', function() {
        galleryThumbs.slideTo(media_position);
      });
      galleryThumbs.on('transitionStart', function(){
        galleryMain.slideTo(media_position);
      });
    }
    else{
      if (!bodyHasClass) {
        var galleryThumbsBoost = new Swiper(".boost-pfs-quickview-wrapper.fancybox-inner  .slider-nav", {
          centeredSlides: false,
          slidesPerView: 4,
          watchOverflow: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true
        });
        var galleryMainBoost = new Swiper(".boost-pfs-quickview-wrapper.fancybox-inner .qv-product-main-images", {
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          thumbs: {
            swiper: galleryThumbsBoost
          }
        });
        galleryMainBoost.slideTo( media_position - 1,1000,false );
        galleryMainBoost.on('slideChangeTransitionStart', function() {
          galleryThumbsBoost.slideTo(media_position);
        });
        galleryThumbsBoost.on('transitionStart', function(){
          galleryMainBoost.slideTo(media_position);
        });
      }
      else{

        var galleryThumbs= new Swiper(".fancybox-inner .qv-product-thumb-images.slider-nav", {
          centeredSlides: false,
          slidesPerView: 4,
          watchOverflow: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideActiveClass:"swiper-slide-active"
        });
        var galleryMain = new Swiper(".fancybox-inner .qv-product-main-images", {
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          }
          ,
          thumbs: {
            swiper: galleryThumbs
          }
        });
        galleryMain.slideTo( media_position - 1,1000,false );
        galleryMain.on('slideChangeTransitionStart', function() {
          galleryThumbs.slideTo(media_position);
        });
        galleryThumbs.on('transitionStart', function(){
          galleryMain.slideTo(media_position);
        });
      }



    }

  }

  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantBadge() {
    const variantBadges =  document.querySelectorAll('[data-badge="variant-level"]');
    if(this.currentVariant){
      let variantRadiosElement = document.querySelector('[data-variantMetafields]');
      let variantMetafields = JSON.parse(variantRadiosElement.getAttribute('data-variantMetafields'));
      var variantLabel = variantMetafields[this.currentVariant.id];

      if(variantBadges){
        variantBadges.forEach(function(variantBadge){
          if(variantLabel.labelText){
            variantBadge.classList.remove('hidden');
            variantBadge.innerHTML = variantLabel.labelText;
            variantBadge.style.color = variantLabel.labelTextColor;
            variantBadge.style.backgroundColor = variantLabel.labelColor;
          } else {
            variantBadge.classList.add('hidden');
            variantBadge.innerHTML = '';
          }
        });
      }
    }
    else {
      variantBadges.forEach(function(variantBadge){
        variantBadge.classList.add('hidden');
        variantBadge.innerHTML = '';
      });
    }

    /*
    // variant dot update
    var variantTitle = (this.currentVariant.title).toLowerCase();
    var variantTitleArray = variantTitle.split(" / ");
    var variantTitleArrayLength = variantTitleArray.length;

    if(variantTitleArrayLength > 1){
      var getAllVariants = document.querySelectorAll('.swatch .swatch-element');
      for (var i = 0; i < variantTitleArrayLength; i++) {
        var currentVariantTitle = variantTitleArray[i].toLowerCase();
        for (var i = 0; i < getAllVariants.length; i++) {
          var getAllVariantsTitle = getAllVariants[i].getAttribute('data-varianttitle');
          var variantDot = getAllVariants[i].querySelector('[data-badge="variant-dot"]');
          if(currentVariantTitle == getAllVariantsTitle){
            variantDot.classList.remove('hidden');
            variantDot.style.backgroundColor = variantLabel.labelColor;
          }else{
            variantDot.classList.add('hidden');
          }
        }
      }
    }
    */
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;
    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.remove('visibility-hidden');

      if(this.currentVariant)
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      const thisProductId = `#${this.getAttribute("product_id")}`;
      const qvid = `${thisProductId} #price-${this.dataset.section}`;
      const qvhtml = new DOMParser().parseFromString(responseText, 'text/html')

      const qvdestination = document.querySelector(qvid);
      const qvsource = qvhtml.querySelector(qvid);
      if (qvsource && qvdestination) qvdestination.innerHTML = qvsource.innerHTML;
      const qvprice = document.querySelector(`.fancybox-inner #price-${this.dataset.section}`);

      if(document.querySelector(".fancybox-inner"))
        document.querySelector(".fancybox-inner").classList.add("change");
      if (qvprice) qvprice.classList.remove('visibility-hidden');
      // this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      var moneySpan = this.getAttribute('priceformat');
      if(moneySpan) {
        var mainformatedPrice = moneySpan.replace(/-?[0-9]*\.?[0-9]+/, Shopify.formatMoney(this.currentVariant.price));
        document.querySelector(".fancybox-inner .price-item--regular").innerHTML=`${mainformatedPrice}`;
      }
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
     const thisProductId = `${this.getAttribute("id")}`;
    const productForm = document.querySelector(`#product-form-${this.dataset.section},  .fancybox-inner #qvproduct_form_${thisProductId}`);
    productForm.classList.add('check');
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const qvnotifyme = productForm.querySelector('.fancybox-inner #notifyme, #notifyme');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if( typeof this.currentVariant != "undefined"){
      var inventoryQty =this.getAttribute('data_'+this.currentVariant.id);
      var minQty = this.getAttribute('data-min-qty');
      if( parseInt(inventoryQty) < minQty){ disable = true;}
      else{disable = false;}
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        addButton.classList.add('hide');
        qvnotifyme.classList.remove('hide');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButton.classList.remove('hide');
        qvnotifyme.classList.add('hide');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }else{
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
      if(fieldsets[0] == fieldset ){
        const $this = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
        var thisValue = $this.getAttribute("value");
        var data_option1= $this.getAttribute('data_option1').replace(/.$/, '');
        var data_option2 = $this.getAttribute('data_option2').replace(/.$/, '');
        var data_option3 = $this.getAttribute('data_option3').replace(/.$/, '');

        //  const el = fieldsets[1].querySelector(`input[value="${data_option2}"]`);
        //   [...el.parentElement.children].forEach(function(sib){
        //     if( sib.tagName == "INPUT"){
        //     sib.classList.remove('available');
        //     sib.classList.add('soldout');
        //     }
        //   });
        //   el.classList.add('available');
      }
      });
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    addButton.disabled = true;
    if (price) price.classList.add('visibility-hidden');

  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;

    });

  }
}

customElements.define('variant-radios', VariantRadios);

// customer dropdown js
const contact_dropdown__tigger = document.querySelector('.customer_dropdown__tigger .trigger__inner');
const customer_mobile_tabs = document.querySelector('.customer_tab_list_mobile');
const tabs_radio = document.querySelectorAll('.customer_tab_list_mobile input[type="radio"]');
const overlay_div = document.querySelector('#minibag_mask');
const active_overlay = document.querySelector('.minibag-mask.dropdown_active_mobile')
const close_icon = document.querySelector('.customer_tab_list_mobile .close_icon')

// if(contact_dropdown__tigger) {
//   contact_dropdown__tigger.addEventListener('click',function(e){
//     e.preventDefault()
//     customer_mobile_tabs.classList.add('active_dropdown');
//     overlay_div.classList.add('dropdown_active_mobile');
//     overlay_div.style.display = 'block';
//     document.body.style.overflow = 'hidden'
//   })
// }

if(close_icon) {
  close_icon.addEventListener('click',function(){
    overlay_div.click()
    customer_mobile_tabs.classList.remove('active_dropdown');
  })
  overlay_div.addEventListener('click',function(){
    customer_mobile_tabs.classList.remove('active_dropdown');
    overlay_div.classList.remove('dropdown_active_mobile');
    overlay_div.style.display = 'none';
    document.body.style.overflow = 'auto'
  })
}

if(tabs_radio) {
  tabs_radio.forEach(function(input){
    input.addEventListener('change',function(e){
      const to_url = e.target.dataset.href;
      window.location = to_url
      const parent_tab_dropdown = e.target.closest('.customer_tab_list_mobile')
      // document.querySelector(`.tabs[data-tab="${to_trigger_tab}"]`).click();;
      if (currentUrl == to_url) {
        e.target.checked = true
      }
      contact_dropdown__tigger.querySelector('p').innerHTML = e.target.value;
      parent_tab_dropdown.classList.remove('active_dropdown')
      overlay_div.style.display = 'none';
      document.body.style.overflow = 'auto'
    })
  })
}

// Home page Instagram feed custom slider - 2021-03-09 By Inscoder HG
class InstafeedPostCarousel extends HTMLElement {
  constructor(el, context) {
    super(el, context);

    this.addEventListener("DOMSubtreeModified", handler);
    this.found = false;
    function handler(event) {

      this.slider = event.target.querySelectorAll('div')[0];
      if(this.slider){
        if(this.found) return;

        this.sliderItems = this.slider.querySelectorAll('.slide-page');
        this.buttonContainer = document.querySelector('.ig__homepage .instafeed__swiper-nav-wrap');
        this.previousButton = document.querySelector('.ig__homepage .instafeed__swiper-nav-prev');
        this.nextButton = document.querySelector('.ig__homepage .instafeed__swiper-nav-next');

        this._setScrollIncrement();
        this._setButtonContainerHeight();

        this.previousButton.addEventListener('click', event => this._handleClick(event));
        this.nextButton.addEventListener('click', event => this._handleClick(event));
        // this.nextButton.addEventListener('click', function(event){
        //   console.log('===== test next button ======'); console.log(event);
        // });
        // this.addEventListener(window, 'resize', () => this._setButtonContainerHeight());
        addEventListener('resize', (event) => this._setButtonContainerHeight());
        addEventListener('resize', (event) => this._setScrollIncrement());
        // Core.Breakpoints.onChange(() => this._setScrollIncrement());

        // The 10% rootMargin is to account for the 10% "sneak peak" of the next card in the slider
        this._observer = new IntersectionObserver(this._handleIntersection.bind(this), { root: this.slider, rootMargin: '0px 10% 0px 0px', threshold: 1.0 });
        this.sliderItems.forEach(item => this._observer.observe(item));

        this.found = true;
      }
    };

    return;

  }

  onMount() {
    // console.log('===============onMount=====================');
  }

  /**
   * Handles the click event for when the previous/next buttons are clicked.
   * Slider scrolls one card-length per click.
   * @param {Event} event - The 'click' event object
   */
  _handleClick(event) {
    event.preventDefault();

    const thisSlider = document.querySelector('instafeed-post>div');
    const name = event.target.getAttribute('name');

    if(name == 'next'){
      var nextScroll = thisSlider.scrollLeft + this.scrollIncrement
      thisSlider.scrollTo({ left: nextScroll, behavior: 'smooth' });
    } else{
      var prevScroll = thisSlider.scrollLeft - this.scrollIncrement
      thisSlider.scrollTo({ left: prevScroll, behavior: 'smooth' });
    }
  }

  /**
   *
   * Callback for IntersectionObserver.
   * Toggle button visibility based on users scroll position in slider
   * @param {IntersectionObserverEntry[]} entries
   */
  _handleIntersection(entries) {
    // Safari doesn't support `scrollTo`'s `smooth` behavior. Therefore,
    // process the entries in batches as multiple cards may become visible
    // in a single scroll movement
    const intersectionCardIndices = entries
      .filter(entry => entry.isIntersecting)
      .map(({ target }) => Array.prototype.indexOf.call(this.sliderItems, target));

    if (intersectionCardIndices.length === 0) return;

    const containsFirstCard = intersectionCardIndices.includes(0);
    const containsLastCard = intersectionCardIndices.includes(this.sliderItems.length - 1);

    this.previousButton.classList.toggle('hidden', containsFirstCard);
    this.nextButton.classList.toggle('hidden', containsLastCard);
  }

  /**
   * Determine how many cards to scroll when previous/next buttons
   * are clicked.
   */
  _setScrollIncrement() {
    let windowWidth = window.screen.availWidth;
    if(windowWidth <= 480){
      this.multiplier = 2
    } else if(windowWidth > 480 && windowWidth <= 768){
      this.multiplier = 3
    } else if(windowWidth > 768 && windowWidth <= 1024){
      this.multiplier = 4
    } else if(windowWidth > 1024){
      this.multiplier = 5
    }

    if (this.sliderItems[0] !== undefined) {
      // this.scrollIncrement = this.sliderItems[0].clientWidth * this.multiplier; // Multiple slides scroll
      this.scrollIncrement = this.sliderItems[0].clientWidth; // single slide scroll
    }
  }

  /**
   * Manually set button container height so buttons are centred
   * relative to product card images
   */
  _setButtonContainerHeight() {
    if (!this.buttonContainer) return;
    const { offsetHeight } = this.sliderItems[0];
    this.buttonContainer.style.height = `${offsetHeight}px`;
  }
}

customElements.define('instafeed-post', InstafeedPostCarousel);


// Cart page
document.addEventListener("DOMContentLoaded", (event) => {
  if(window.location.href.includes('cart')) {

    let cart_footer_cnt = document.querySelector('.cart__footer .js-contents');
    let cart_footer_text = document.querySelectorAll('.cart__footer .cart__ctas small');
    let cart_footer_block = document.querySelector('#main-cart-footer');
    const cart_mobile_text = document.querySelector('.js-contents .cart-items.for-mobile .progress-warp')
    const observer = new MutationObserver((mutationsList, observer) => {
      // Iterate over the list of mutations
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // Handle added or removed nodes
          for (let addedNode of mutation.addedNodes) {

            if(cart_footer_cnt) {
              cart_footer_cnt.style.display = 'block';

            }

            if(cart_footer_text.length) {
              cart_footer_text.forEach((ev)=>ev.style.display = 'block')
            }

            if(cart_mobile_text) {
              cart_mobile_text.style.display = 'block'
            }
          }

          // Handle removed nodes
          for (let removedNode of mutation.removedNodes) {
            cart_footer_cnt.style.display = 'none'
            if(cart_footer_text.length) {
              cart_footer_text.forEach((ev)=>ev.style.display = 'none')
            }

            if(cart_footer_block) {
              cart_footer_block.style.minHeight = '100%'
            }
            if(cart_mobile_text) {
              cart_mobile_text.style.display = 'none'
            }
          }
        }
      }
    });

    let demoElem = document.getElementById('birdchime-slots-box')
    observer.observe(demoElem, {childList: true, subtree: true});
  }
})

// // widget check to load simplee membership
// const app_widget_div = document.getElementById('simplee-membership-link');
// const membership_tab = document.querySelector('.membership_link')
// if(!app_widget_div) {
//   if (membership_tab) {
//     membership_tab.closest('.tab-list__tab').classList.add('hide')
//   }
// } else {
//   if (membership_tab) {
//     membership_tab.closest('.tab-list__tab').classList.remove('hide')
//   }
// }